module.exports = __webpack_public_path__ + "img/auth.2f267978.jpg";